import React, { useState, useContext } from 'react';
import {
  Container,
  Grid,
  Accordion as SemanticAccordion,
} from 'semantic-ui-react';
import InlineSvg from './InlineSvg';
import { replaceUrls } from '../helpers/common';
import { LargeMonitorContext } from '../context';
import { toSnakeCase } from '../helpers/common';

const FAQs = (props) => {
  const [activeIndex, setActiveIndex] = useState(0);

  const handleClick = (e, titleProps) => {
    const { index } = titleProps;
    const newIndex = activeIndex === index ? -1 : index;

    setActiveIndex(newIndex);
  };
  const handleKeyDown = (e, targetElem) => {
    if (e.key === "Enter" && targetElem) {
      targetElem.click();
    }
  };

  const { module } = props;
  const { anchorTagLinkText, title, faq } = module;
  const largeMonitorContext = useContext(LargeMonitorContext);

  return (
    <section id={anchorTagLinkText && `${toSnakeCase(anchorTagLinkText)}`}>
      <Container>
        <Grid>
          <Grid.Row>
            {largeMonitorContext && <Grid.Column width={1}></Grid.Column>}
            <Grid.Column mobile={12} tablet={12} computer={10} largeScreen={9}>
              {title && <h4 className="accordions__title">{title}</h4>}
              <SemanticAccordion
                data-testid="accordions"
                className="accordions"
              >
                {faq.map((faq, key) => {
                  const active = activeIndex === key;
                  return (
                    <React.Fragment key={key}>
                      <SemanticAccordion.Title
                        active={active}
                        index={key}
                        onClick={handleClick}
                        tabIndex="0"
                        onKeyDown={(e) => {
                          handleKeyDown(e, e.target)
                        }}
                      >
                        {faq.faq.title}
                        <InlineSvg
                          className={`accordions__icon ${
                            active ? 'accordions__icon--active' : ''
                          }`}
                          name={active ? 'minus' : 'plus'}
                          color={active ? 'brand-secondary' : 'blue'}
                        />
                      </SemanticAccordion.Title>
                      <SemanticAccordion.Content
                        active={active}
                        dangerouslySetInnerHTML={{
                          __html: replaceUrls(faq.faq.content),
                        }}
                      />
                    </React.Fragment>
                  );
                })}
              </SemanticAccordion>
            </Grid.Column>
            {largeMonitorContext && <Grid.Column width={1}></Grid.Column>}
          </Grid.Row>
        </Grid>
      </Container>
    </section>
  );
};

export default FAQs;
